import React from "react";
import SiteFooter from "@/components/SiteFooter";
import { PsyGestionIcon } from "@/components/PsyGestionLogo";

const C = {
  navy: "#1B3A5C",
  teal: "#2A9D8F",
  muted: "#6B85A3",
  border: "#D6E4F0",
  white: "#FFFFFF",
};

const sections = [
  {
    title: "1. Objet",
    content:
      "Les présentes conditions générales régissent l'accès et l'utilisation de PsyGestion, outil de gestion fiscale et Mentor Fiscal pour psychologues libéraux, accessible à l'adresse dashboard.freedomarchitect.io.",
  },
  {
    title: "2. Acceptation",
    content:
      "En créant un compte, vous acceptez sans réserve les présentes CGU. Si vous n'acceptez pas ces conditions, vous ne pouvez pas utiliser PsyGestion.",
  },
  {
    title: "3. Description du service",
    content:
      "PsyGestion est un outil d'aide à la gestion fiscale (« Mentor Fiscal ») spécialisé pour les psychologues exerçant en libéral (Micro-BNC ou BNC classique). Il intègre un assistant IA qui fournit des analyses et recommandations personnalisées. Ces informations sont données à titre purement indicatif et ne constituent en aucun cas un conseil fiscal, juridique ou comptable certifié. Elles ne remplacent pas les conseils d'un expert-comptable ou d'un conseiller fiscal agréé. L'utilisateur·rice reste seul·e responsable de ses déclarations fiscales.",
  },
  {
    title: "4. Plans et facturation",
    content: (
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <p>PsyGestion propose deux plans :</p>
        <p>
          <strong>Plan Découverte (gratuit)</strong> : accès permanent aux fonctionnalités de base (tableau de bord simplifié, saisie jusqu'à 10 recettes/mois, 3 simulations/mois, 1 message assistant IA, rappels URSSAF par email). Aucune carte bancaire requise.
        </p>
        <p>
          <strong>Plan Pro à 47€/mois</strong> : accès illimité à toutes les fonctionnalités, y compris l'assistant fiscal IA, l'export PDF, les charges 2035 et le comparatif multi-années. L'abonnement est géré par Stripe Payments Europe Ltd. et facturé mensuellement. L'abonnement est sans engagement et résiliable à tout moment depuis l'espace Mon Profil. La résiliation prend effet à la fin de la période de facturation en cours. Aucun remboursement au prorata n'est effectué.
        </p>
        <p>
          Les tarifs peuvent évoluer. Les abonné·e·s actif·ve·s seront notifié·e·s par email au moins 30 jours avant toute modification tarifaire et conservent le droit de résilier sans frais avant l'entrée en vigueur du nouveau tarif.
        </p>
      </div>
    ),
  },
  {
    title: "5. Assistant IA — Mentor Fiscal",
    content:
      "L'assistant fiscal IA de PsyGestion fournit des analyses personnalisées basées sur les données saisies par l'utilisateur·rice et les taux fiscaux en vigueur (source ARAPL 2025, taux CIPAV). Ses réponses sont générées par un modèle d'intelligence artificielle et sont données à titre informatif uniquement. Elles ne constituent pas un avis fiscal certifié. L'éditeur décline toute responsabilité quant aux décisions prises sur la base des réponses de l'assistant. Les données transmises à l'assistant ne sont pas utilisées pour entraîner des modèles d'IA publics ou tiers.",
  },
  {
    title: "6. Responsabilités",
    content:
      "PsyGestion fournit des estimations basées sur les données saisies par l'utilisateur·rice et les taux fiscaux en vigueur (taux CIPAV, abattement Micro-BNC 34%, seuil 83 600€). Ces calculs sont fournis à titre indicatif uniquement. Freedom Architect ne saurait être tenu responsable d'éventuelles erreurs de calcul, de l'indisponibilité temporaire du service, ni des décisions prises sur la base de ces estimations.",
  },
  {
    title: "7. Données personnelles",
    content: (
      <p>
        Le traitement de vos données personnelles est décrit dans notre{" "}
        <a href="/confidentialite" style={{ color: C.teal }}>Politique de Confidentialité</a>.
        Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement et de portabilité de vos données. Vous pouvez supprimer votre compte et toutes vos données depuis l'onglet Mon Profil.
      </p>
    ),
  },
  {
    title: "8. Propriété intellectuelle & protection des algorithmes",
    content: (
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <p>
          L'ensemble du contenu de PsyGestion — code source, design, textes, <strong>algorithmes de calcul fiscal</strong>,
          base de règles métier, marque et interface graphique — est la propriété exclusive de Freedom Architect,
          protégé par le Code de la propriété intellectuelle (articles L.111-1 et suivants).
        </p>
        <p>
          <strong>Il est expressément interdit de :</strong>
        </p>
        <ul style={{ paddingLeft: 20, margin: 0 }}>
          <li>Reproduire, copier ou distribuer tout ou partie du service sans autorisation écrite préalable ;</li>
          <li>
            Procéder à de l'<strong>ingénierie inverse</strong> (<em>reverse engineering</em>), décompiler,
            désassembler ou tenter d'extraire les algorithmes de calcul fiscal, les formules de cotisations
            ou toute logique métier du service, par quelque moyen que ce soit (inspection du code réseau,
            débogueur navigateur, interception de requêtes, scraping, etc.) ;
          </li>
          <li>Créer des œuvres dérivées ou des produits concurrents fondés sur les algorithmes de PsyGestion ;</li>
          <li>Contourner les mesures techniques de protection mises en place (authentification, chiffrement, RLS).</li>
        </ul>
        <p>
          Toute violation constitue une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code
          de la propriété intellectuelle, passible de trois ans d'emprisonnement et de 300 000€ d'amende,
          ainsi que de dommages et intérêts civils.
        </p>
        <p>
          Les algorithmes de calcul (cotisations CIPAV, barème IR, comparatif Micro-BNC / BNC classique)
          sont exécutés côté serveur dans des fonctions sécurisées afin de protéger notre propriété
          intellectuelle. Toute tentative d'extraction ou de reproduction sera poursuivie.
        </p>
      </div>
    ),
  },
  {
    title: "9. Modification des CGU",
    content:
      "Nous nous réservons le droit de modifier les présentes CGU. Les utilisateur·rice·s actif·ve·s seront notifié·e·s par email 30 jours avant toute modification substantielle.",
  },
  {
    title: "10. Droit applicable et juridiction",
    content:
      "Les présentes CGU sont soumises au droit français. En cas de litige, et à défaut de résolution amiable, le tribunal compétent est celui du ressort de Toulon (Var).",
  },
  {
    title: "11. Contact",
    content: (
      <p>
        Pour toute question relative aux présentes CGU :{" "}
        <a href="mailto:contact@freedomarchitect.io" style={{ color: C.teal }}>
          contact@freedomarchitect.io
        </a>
      </p>
    ),
  },
];

export default function CGU() {
  return (
    <div style={{ fontFamily: "'Inter', system-ui, -apple-system, sans-serif", backgroundColor: C.white, minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <nav style={{ backgroundColor: C.white, borderBottom: `1px solid ${C.border}`, padding: "16px 20px" }}>
        <div style={{ maxWidth: 680, margin: "0 auto", display: "flex", alignItems: "center", gap: 8 }}>
          <a href="/" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none" }}>
            <PsyGestionIcon size={28} />
            <span style={{ fontWeight: 700, fontSize: 16, color: C.navy }}>PsyGestion</span>
          </a>
        </div>
      </nav>

      <main style={{ flex: 1, padding: "64px 20px" }}>
        <div style={{ maxWidth: 680, margin: "0 auto" }}>
          <h1 style={{ fontSize: 28, fontWeight: 800, color: C.navy, marginBottom: 8 }}>
            Conditions Générales d'Utilisation et de Vente
          </h1>
          <p style={{ fontSize: 13, color: C.muted, marginBottom: 48 }}>
            Dernière mise à jour : mars 2026
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
            {sections.map((s) => (
              <div key={s.title}>
                <h2 style={{ fontSize: 17, fontWeight: 700, color: C.navy, marginBottom: 10 }}>
                  {s.title}
                </h2>
                <div style={{ fontSize: 14, color: C.muted, lineHeight: 1.8 }}>
                  {typeof s.content === "string" ? <p>{s.content}</p> : s.content}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}
